import { format as fnsFormat, add as addFns, differenceInDays } from 'date-fns'
import { es } from 'date-fns/locale'

export function dateFormat(date, format) {
  return fnsFormat(date, format, { locale: es })
}

export function toUTC(date) {
  return date.toUTCString()
}

export function add(date, extension) {
  return addFns(date, extension)
}

// E.g. '03/11'
export function toShortDate(date) {
  const convertedDate = new Date(date)
  return convertedDate
    .toLocaleDateString('es-AR', { dateStyle: 'short' })
    .slice(0, -3)
}

// E.g. '3/11/22'
export function toShortDateWithYear(date) {
  const options: Intl.DateTimeFormatOptions = {
    dateStyle: 'short'
  }
  const convertedDate = new Date(date)
  return convertedDate.toLocaleDateString('es-AR', options)
}

// E.g. '3 de noviembre'
export function toLocaleDate(date) {
  const dateToFormat = new Date(date)
  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC'
  }
  return dateToFormat.toLocaleDateString('es-AR', options)
}

export const isToday = (someDate) => {
  const today = new Date()
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  )
}

export const humanReadable = (created_at) => {
  const localeDate = new Date(created_at)

  const isToday = localeDate.getDate() === new Date().getDate()
  if (isToday) return 'Hoy'

  const isYesterday = localeDate.getDate() === new Date().getDate() - 1
  if (isYesterday) return 'Ayer'

  const diffDays = differenceInDays(new Date(), localeDate)
  const dayOfWeek = dateFormat(new Date(created_at), 'EEEE')

  if (diffDays <= 6)
    return `${dayOfWeek[0].toUpperCase()}${dayOfWeek.substring(1)}`

  const daysAgo = dateFormat(localeDate, 'dd/MM/yy')
  return daysAgo
}
